import { moment } from "../../date";
import { z } from "zod";

export const tourWaveFormSchema = z
	.object({
		name: z.string().min(1),
		startTime: z.string().min(1),
		endTime: z.string().min(1),
		weekdays: z
			.array(z.number())
			.min(1, { message: "At least one day must be selected" })
			.default([]),
		cutoffOffset: z.number().min(0).default(0),
	})
	.superRefine((data, context) => {
		const startTime = moment().setTime(data.startTime);
		const endTime = moment().setTime(data.endTime);
		if (startTime.isAfter(endTime)) {
			context.addIssue({
				code: "custom",
				path: ["endTime"],
				message: "End time must be after start time",
			});
		}
	});

export type TourWaveFormSchema = z.infer<typeof tourWaveFormSchema>;
